import { tw } from "@careinfo/tailwind";
import React from "react";

const GroupedDataTable = ({ data }: { data: Record<string, any[]> }) => {
  return (
    <div
      className={tw`overflow-x-auto  bg-[#fefefe] rounded-md border border-[#dcdcdc] shadow`}
    >
      <table className={tw`w-full rounded-md overflow-hidden border-collapse`}>
        <thead>
          <tr className={tw`text-white border-b bg-primary`}>
            <th className={tw`px-4 py-2 text-left`}>Product Name</th>
            <th className={tw`px-4 py-2 text-left`}>Unit</th>
            <th className={tw`px-4 py-2 text-left`}>Opening Qunatity</th>
            <th className={tw`px-4 py-2 text-left`}>Received</th>
            <th className={tw`px-4 py-2 text-left`}>Issued</th>
            <th className={tw`px-4 py-2 text-left`}>Closing Quantity</th>
          </tr>
        </thead>

        <tbody>
          {Object.entries(data).map(([productName, entries]) => {
            const totalOpeningQuantity = entries.reduce(
              (sum, item) => sum + Number(item?.account?.opening_quantity || 0),
              0
            );

            const totalReceived = entries.reduce(
              (sum, item) =>
                sum + parseFloat(item?.is_sales ? 0 : item?.quantity || 0),
              0
            );
            const totalIssued = entries.reduce(
              (sum, item) =>
                sum + parseFloat(item?.is_sales ? item?.quantity || 0 : 0),
              0
            );
            const closingBalance =
              totalOpeningQuantity + totalReceived - totalIssued;
            return (
              <React.Fragment key={productName}>
                <tr className={tw`bg-white border-b`}>
                  <td
                    colSpan={5}
                    className={tw`px-4 py-2 font-medium text-primary `}
                  >
                    {productName}
                  </td>
                </tr>

                {entries.map((item, index) => (
                  <tr key={item.id} className={tw`border-b`}>
                    <td className={tw`px-4 py-2`}>{item?.account?.name}</td>
                    <td className={tw`px-4 py-2`}>
                      {item?.account?.unit?.name}
                    </td>
                    <td className={tw`px-4 py-2`}>
                      {item?.account?.opening_quantity}
                    </td>
                    <td className={tw`px-4 py-2`}>
                      {item?.is_sales
                        ? ""
                        : Number(item?.quantity || 0).toFixed(2)}
                    </td>
                    <td className={tw`px-4 py-2`}>
                      {item?.is_sales
                        ? Number(item?.quantity || 0).toFixed(2)
                        : ""}
                    </td>
                    <td className={tw`px-4 py-2`}>
                      {Number(item?.closing_quantity || 0).toFixed(2)}
                    </td>
                  </tr>
                ))}

                <tr className={tw`bg-gray-200 font-semibold border-b`}>
                  <td className={tw`px-4 py-2`}>Total</td>
                  <td className={tw`px-4 py-2`}></td>
                  <td className={tw`px-4 py-2 `}></td>
                  <td className={tw`px-4 py-2 `}>{totalReceived.toFixed(2)}</td>
                  <td className={tw`px-4 py-2`}>{totalIssued.toFixed(2)}</td>
                  <td className={tw`px-4 py-2 `}>
                    {closingBalance.toFixed(2)}
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default GroupedDataTable;
